module.exports = __webpack_public_path__ + "img/service_3.2489f4f8.jpg";